import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const Counter = () => {
  const [departments, setDepartments] = useState(0);
  const [faculties, setFaculties] = useState(0);
  const [programs, setPrograms] = useState(0);
  const [colleges, setColleges] = useState(0);
  const [acres, setAcres] = useState(0);
  const [ugc, setUgc] = useState(0);

  const { ref: counterRef, inView } = useInView({
    triggerOnce: true, // Trigger the animation only once when in view
    threshold: 0.2,    // Adjust the threshold to fire when 20% of the component is visible
  });

  useEffect(() => {
    if (inView) {
      animateCounter(setDepartments, 0, 40, 2000);
      animateCounter(setFaculties, 0, 214, 2000);
      animateCounter(setPrograms, 0, 98, 2000);
      animateCounter(setColleges, 0, 724, 2000);
      animateCounter(setAcres, 0, 222, 2000);
      animateCounter(setUgc, 0, 22, 2000);
    }
  }, [inView]);

  const animateCounter = (setter, start, end, duration) => {
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = Math.ceil(progress * (end - start) + start);
      setter(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };

  return (
    <div className="part-ccsu mt-5 mb-5" ref={counterRef}>
      <div className="overlay" />
      <div>
        <h1 className="my-heading text-center mb-3 text-white">
          Be proud to be a part of CCSU
        </h1>
      </div>
      <div className="container main-box">
        <div className="boxes">
          <div className="box">
            <img src="assets/images/part-icon-1.svg" alt="" />
            <div className="down">
              <h1 className="counter">{departments}</h1>
              <p>Departments</p>
            </div>
          </div>
          <div className="box">
            <img src="assets/images/part-icon-2.svg" alt="" />
            <div className="down">
              <h1 className="counter">{faculties}</h1>
              <p>Faculties</p>
            </div>
          </div>
          <div className="box">
            <img src="assets/images/part-icon-3.svg" alt="" />
            <div className="down">
              <h1 className="counter">{programs}</h1>
              <p>Programs Offered</p>
            </div>
          </div>
          <div className="box">
            <img src="assets/images/part-icon-4.svg" alt="" />
            <div className="down">
              <h1 className="counter">{colleges}</h1>
              <p>Affiliated Colleges</p>
            </div>
          </div>
          <div className="box">
            <img src="assets/images/part-icon-5.svg" alt="" />
            <div className="down">
              <h1 className="counter">{acres}</h1>
              <p>Acres</p>
            </div>
          </div>
          <div className="box">
            <img src="assets/images/part-icon-6.svg" alt="" />
            <div className="down">
              <h1 className="counter">{ugc}</h1>
              <p>UGC Sponsored</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Counter;
